import React from 'react';
import { IconContainer } from './IconContainer';

const ArrowBackIcon = (props) => {
    return (
        <IconContainer ariaLabel="arrow-back" cursor="pointer" style={{ transform: `rotate(${props.rotate}deg)` }} { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path>
            </svg>
        </IconContainer>
    )
}

export { ArrowBackIcon };